/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/require-returns */
import { ReactElement, useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';
import AlertAndSuggestions from './AlertsAndSuggestion';
import HourlyBoxTrends from './HourlyBoxTrends';
import HeatMapTrends from './WeeklyBoxTrends';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Comparison from './Comparison';
import AlertAnalytics from './AlertAnalytics';
import { getAnlayiticsTrends } from '../../services/dashboard-service';
import sortDataByDate from './SortingHeatMap';
import { useData } from '../../context/data.context';
import { sortWeeklyData } from '../../_helpers/globalHelper';
import ApexHeatMap from '../ApexHeatMap';
import ApexHeatMapTrends from './ApexHeatmap';
import { DeviceType } from '../../constants/telosair-interfaces';

// import { useData } from '../../context/data.context';

// TO-DO Add sensors using devices in useData.
type AnalyticsProps = {
  selectedDevices: number[];
  selectedParameters: string[];
  timeSpanDate: {
    startDate: number;
    endDate: number;
  };
};
type HeatmapData = {
  [key: string]: number;
};

type zoomedChartTypes =
  | 'hourly-box-trends'
  | 'weekly-box-trends'
  | 'alert-analytics'
  | 'weekly-heat-trends'
  | 'daily-heat-trends'
  | 'hourly-heat-trends'
  | 'monthly-box-trends';

type analyticsdata = {
  data: number[][];
  heatresponse?: any;
  xaxis: any[];
};

type PairedDates = {
  month: number;
  weekNumber: number;
  dates: { dateString: string; dayOfWeek: number }[];
};
/**
 * Fuction to convert the response in required format.
 * @param props - Required Props.
 * @returns -The Required Data for Box and Whisker.
 */
function ChatFormatedData(props: analyticsdata): { label: any; y: number[] }[] {
  return props
    ? props.data.map((dataArray, index) => ({
        label: props.xaxis[index],
        y: [dataArray[0], dataArray[1], dataArray[3], dataArray[4], dataArray[2]]
      }))
    : [];
}

/**
 * Analytics renders the Data in graphs.
 * @param props - Properties of Analytics component.
 * @returns - Analytics Page.
 */
export default function Analytics(props: AnalyticsProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { selectedDevices, selectedParameters, timeSpanDate } = props;
  const ZoomOutViewRef = useRef<HTMLDivElement>(null);
  const ZoomInViewRef = useRef<HTMLDivElement>(null);
  const [zoomedChartType, setZoomedChartType] = useState<zoomedChartTypes | null>(null);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const clientName = sessionStorage.getItem('client_name');
  const [monthlydata, setMonthlyData] = useState<analyticsdata | null>(null);
  const [weeklydata, setWeeklyData] = useState<analyticsdata | null>(null);
  const [hourlydata, setHourlyData] = useState<analyticsdata | null>(null);
  const [heatmapDataHourly, setHeatMapDataHourly] = useState<HeatmapData | null>(null);
  const [heatmapDataWeekly, setHeatMapDataWeekly] = useState<HeatmapData | null>(null);
  const [heatmapDataDaily, setHeatMapDataDaily] = useState<HeatmapData | null>(null);
  const { userConfigData, devices } = useData();
  const timeZone = userConfigData?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [resizing, setResizing] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [mapHeight, setMapHeight] = useState(0);
  const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.MIXED);
  useEffect(() => {
    /**
     * Handles resize of window.
     */
    const handleResize = (): void => {
      setResizing((prev) => !prev);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (selectedDevices && selectedDevices.length > 0) {
      const selectedDeviceTypes = selectedDevices
        .map((deviceId) => devices.find((device) => device.id === deviceId)?.deviceType)
        .filter(Boolean);

      if (selectedDeviceTypes.length > 0) {
        // If all selected devices have the same type, use that type
        const uniqueTypes = Array.from(new Set(selectedDeviceTypes));
        setDeviceType(uniqueTypes.length === 1 ? (uniqueTypes[0] as DeviceType) : DeviceType.MIXED);
      } else {
        setDeviceType(DeviceType.MIXED);
      }
    }
  }, [selectedDevices, devices]);

  // DailyMap Data required for heatMaps.
  const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUNE',
    'JULY',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC'
  ];
  /**
   * Function to get Month.
   * @param monthIndex -Index of the month.
   */
  const monthvalue = (monthIndex: number): string => {
    return months[monthIndex - 1];
  };

  /**
   * Fetch the MonthlyBoxPlot.
   */
  const fetchMonthlyBox = async (): Promise<void> => {
    setIsDataLoading(true);
    try {
      if (clientName) {
        const response = await getAnlayiticsTrends({
          clients: [clientName],
          endDate: timeSpanDate.endDate,
          parameter: selectedParameters[0],
          sensors: selectedDevices.join(','),
          startDate: timeSpanDate.startDate,
          timeZone,
          type: 'monthlyBox'
        });
        setMonthlyData({
          ...response.data,
          xaxis: response.data.xaxis.map((item: number) => monthvalue(item))
        });
        setIsDataLoading(false);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      setMonthlyData(null);
      setIsDataLoading(false);
    }
  };
  /**
   * Fetch the WeeklyBoxPlot.
   */
  const fetchWeeklyBox = async (): Promise<void> => {
    setIsDataLoading(true);
    try {
      if (clientName) {
        const response = await getAnlayiticsTrends({
          clients: [clientName],
          endDate: timeSpanDate.endDate,
          parameter: selectedParameters[0],
          sensors: selectedDevices.join(','),
          startDate: timeSpanDate.startDate,
          timeZone,
          type: 'weeklyBox'
        });
        if (response.data) {
          setWeeklyData(sortWeeklyData(response.data));
        }
        setIsDataLoading(false);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      setWeeklyData(null);
      setIsDataLoading(false);
    }
  };
  /**
   * Fetch the HourlyBoxPlot.
   */
  const fetchHourlyBox = async (): Promise<void> => {
    setIsDataLoading(true);
    try {
      if (clientName) {
        const response = await getAnlayiticsTrends({
          clients: [clientName],
          endDate: timeSpanDate.endDate,
          parameter: selectedParameters[0],
          sensors: selectedDevices.join(','),
          startDate: timeSpanDate.startDate,
          timeZone,
          type: 'dailyBox'
        });
        setHourlyData(response.data);
        setIsDataLoading(false);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      setHourlyData(null);
      setIsDataLoading(false);
    }
  };
  /**
   * Fetch the HourlyHeatMap.
   */
  const fetchHourlyHeatMap = async (): Promise<void> => {
    setIsDataLoading(true);
    try {
      if (clientName) {
        const response = await getAnlayiticsTrends({
          clients: [clientName],
          endDate: timeSpanDate.endDate,
          parameter: selectedParameters[0],
          sensors: selectedDevices.join(','),
          startDate: timeSpanDate.startDate,
          timeZone,
          type: 'hourlyHeat'
        });
        setHeatMapDataHourly(response.data.heatMapResponse);
        setIsDataLoading(false);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      setHeatMapDataHourly(null);
      setIsDataLoading(false);
    }
  };
  /**
   * Fetch the DailyHeatMap.
   */
  const fetchDailyHeatMap = async (): Promise<void> => {
    setIsDataLoading(true);
    try {
      if (clientName) {
        const response = await getAnlayiticsTrends({
          clients: [clientName],
          endDate: timeSpanDate.endDate,
          parameter: selectedParameters[0],
          sensors: selectedDevices.join(','),
          startDate: timeSpanDate.startDate,
          timeZone,
          type: 'dailyHeat'
        });
        setHeatMapDataDaily(response.data.heatMapResponse);
        setIsDataLoading(false);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      setHeatMapDataDaily(null);
      setIsDataLoading(false);
    }
  };
  /**
   * Fetch the WeeklyHeatMap.
   */
  const fetchWeeklyHeatMap = async (): Promise<void> => {
    setIsDataLoading(true);
    try {
      if (clientName) {
        const response = await getAnlayiticsTrends({
          clients: [clientName],
          endDate: timeSpanDate.endDate,
          parameter: selectedParameters[0],
          sensors: selectedDevices.join(','),
          startDate: timeSpanDate.startDate,
          timeZone,
          type: 'weekelyHeat'
        });
        setHeatMapDataWeekly(response.data.heatMapResponse);
        setIsDataLoading(false);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      setHeatMapDataWeekly(null);
      setIsDataLoading(false);
    }
  };
  useEffect(() => {
    fetchMonthlyBox();
    fetchWeeklyBox();
    fetchHourlyBox();
    fetchHourlyHeatMap();
    fetchWeeklyHeatMap();
    fetchDailyHeatMap();
  }, [selectedDevices, selectedParameters, timeSpanDate]);

  /**
   * Function to handle zoom button click.
   * @param type - Type of graph.
   */
  const onZoom = (type: zoomedChartTypes): void => {
    setZoomedChartType(type);
  };

  useEffect(() => {
    if (ZoomInViewRef.current && ZoomOutViewRef.current) {
      if (!zoomedChartType) {
        ZoomInViewRef.current.style.display = 'none';
        ZoomOutViewRef.current.style.display = 'flex';
      } else {
        ZoomInViewRef.current.style.display = 'flex';
        ZoomOutViewRef.current.style.display = 'none';
      }
    }
  }, [zoomedChartType]);

  // Data for Hourly heatMap.
  const HOURLYDATE = heatmapDataHourly
    ? Object.keys(heatmapDataHourly).map((e) => {
        return e.split(' ')[0];
      })
    : [];
  const xhourlyvalues = Array.from(new Set(HOURLYDATE));
  const xhourlyLabels = xhourlyvalues.slice().sort((a, b) => a.localeCompare(b));
  const yhourlyLabels = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23'
  ];
  const hourdata: number[][] = new Array(yhourlyLabels.length).fill(0).map((_, yIndex) =>
    // eslint-disable-next-line no-shadow
    new Array(xhourlyLabels.length).fill(0).map((_, xIndex) => {
      const yLabel = yhourlyLabels[yIndex];
      const xLabel = xhourlyLabels[xIndex];
      // eslint-disable-next-line no-unused-expressions, array-callback-return
      const matchingKey = heatmapDataHourly
        ? Object.keys(heatmapDataHourly).find((a) => {
            const [date, hour] = a.split(' ');
            return date === xLabel && hour === yLabel;
          })
        : '';
      if (matchingKey && heatmapDataHourly) {
        return heatmapDataHourly[matchingKey];
      }
      return -9999;
    })
  );
  // WeeklyMap Data required for heat Maps.
  const xweeklyLabels = ['0', '1', '2', '3', '4', '5', '6'];
  const xweekLabels = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursady',
    'Friday',
    'Saturday'
  ];
  const weekdata: number[][] = new Array(yhourlyLabels.length).fill(0).map((_, yIndex) =>
    // eslint-disable-next-line no-shadow
    new Array(xweeklyLabels.length).fill(0).map((_, xIndex) => {
      const yLabel = yhourlyLabels[yIndex];
      const xLabel = xweeklyLabels[xIndex];
      // eslint-disable-next-line no-unused-expressions, array-callback-return
      const matchingKey = heatmapDataWeekly
        ? Object.keys(heatmapDataWeekly).find((a) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [d, dayNumber, hour] = a.split(' ');
            // Convert dayNumber to match xweeklyLabels index
            // In xweeklyLabels, Sunday is '0', Monday is '1', etc
            const adjustedDayNumber = dayNumber === '7' ? '0' : dayNumber;
            return adjustedDayNumber === xLabel && hour === yLabel;
          })
        : '';

      if (matchingKey && heatmapDataWeekly) {
        return heatmapDataWeekly[matchingKey];
      }
      return -9999;
    })
  );

  /**
   * Getting month,day,weeknumber using the date value from api response.
   * @param data - Data.
   */
  const extractAndPairDates = (data: Record<string, number> | never[]): PairedDates[] => {
    const result: PairedDates[] = [];
    let currentPair: PairedDates | null = null;
    // eslint-disable-next-line no-restricted-syntax
    for (const dateString in data) {
      if (Object.prototype.hasOwnProperty.call(data, dateString)) {
        const date = moment.tz(dateString.trim(), 'MM.DD.YYYY', timeZone);
        const month = date.month() + 1;
        const weekNumber = date.week();
        const dayOfWeek = date.day();
        if (currentPair && currentPair.month === month && currentPair.weekNumber === weekNumber) {
          currentPair.dates.push({ dateString, dayOfWeek });
        } else {
          currentPair = { month, weekNumber, dates: [{ dateString, dayOfWeek }] };
          result.push(currentPair);
        }
      }
    }
    return result;
  };
  const sortdailydata = heatmapDataDaily ? sortDataByDate(heatmapDataDaily) : [];
  const extracteddata = sortdailydata ? extractAndPairDates(sortdailydata) : [];
  const xdailylabels = extracteddata.map((e) => {
    return e.month;
  });
  // eslint-disable-next-line radix
  const ydailylabel = xdailylabels.map((e) => e).map(monthvalue);

  const dailydata: number[][] = new Array(xweekLabels.length).fill(0).map((_, yIndex) =>
    // eslint-disable-next-line no-shadow
    new Array(extracteddata.length).fill(0).map((_, xIndex) => {
      const xLabel = extracteddata[xIndex].month;
      // eslint-disable-next-line no-unused-expressions
      const matchingKey = heatmapDataDaily
        ? Object.keys(heatmapDataDaily).find((a) => {
            const date = moment.tz(a, 'MM.DD.YYYY', timeZone);
            const dayOfWeek = date.day();
            const weekNumber = date.week();
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [month, day, year] = a.split('.');
            const formattedMonth = month.startsWith('0') ? month.slice(1) : month;
            return (
              formattedMonth === xLabel.toString() &&
              dayOfWeek === yIndex &&
              weekNumber === extracteddata[xIndex].weekNumber
            );
          })
        : '';

      if (matchingKey && heatmapDataDaily) {
        return heatmapDataDaily[matchingKey];
      }
      return -9999;
    })
  );

  useEffect(() => {
    if (ZoomOutViewRef.current !== null) {
      setMapHeight(ZoomOutViewRef.current.clientHeight);
    }
  }, [resizing]);

  const apexHourlyData = heatmapDataHourly
    ? Object.entries(heatmapDataHourly)
        // Sort by date first
        .sort(([dateA], [dateB]) => dateA.localeCompare(dateB))
        // Group by hour and transform to final format
        .reduce(
          (acc: { name: string; data: { x: string; y: number | null }[] }[], [dateTime, value]) => {
            const [date, hour] = dateTime.split(' ');
            const formattedDate = moment(date, 'MM.DD.YYYY').format('DD MMM');

            // Find existing hour group or create new one
            let hourGroup = acc.find((group) => group.name === hour);
            if (!hourGroup) {
              hourGroup = { name: hour, data: [] };
              acc.push(hourGroup);
            }

            hourGroup.data.push({
              x: formattedDate,
              y: value as number
            });

            return acc;
          },
          []
        )
        // Sort groups by hour
        .sort((a, b) => Number(b.name) - Number(a.name))
    : [];

  const apexWeeklyData = heatmapDataWeekly
    ? Object.entries(heatmapDataWeekly)
        // Sort by date first
        .sort(([dateA], [dateB]) => dateA.localeCompare(dateB))
        // Group by hour and transform to final format
        .reduce(
          (acc: { name: string; data: { x: string; y: number | null }[] }[], [dateTime, value]) => {
            const [date, dayNumber, hour] = dateTime.split(' ');

            // Convert hour to group name (0-23)
            const hourName = hour || '0';

            // Find existing hour group or create new one
            let hourGroup = acc.find((group) => group.name === hourName);
            if (!hourGroup) {
              hourGroup = { name: hourName, data: [] };
              acc.push(hourGroup);
            }

            // Map day number to weekday name
            const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            const weekdayIndex = (Number(dayNumber) - 1 + 6) % 7; // Adjust to make Sunday first
            const weekday = weekdays[weekdayIndex];

            // Add or update data point for this weekday
            const existingDataPoint = hourGroup.data.find((point) => point.x === weekday);
            if (existingDataPoint) {
              existingDataPoint.y = value as number;
            } else {
              hourGroup.data.push({
                x: weekday,
                y: value as number
              });
            }

            return acc;
          },
          []
        )
        // Sort groups by hour (0-23)
        .sort((a, b) => Number(b.name) - Number(a.name))
        // Ensure each hour has all 7 weekdays
        .map((hourGroup) => {
          const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          const completeData = weekdays.map((weekday) => {
            const existing = hourGroup.data.find((d) => d.x === weekday);
            return existing || { x: weekday, y: null };
          });
          return {
            ...hourGroup,
            data: completeData
          };
        })
    : [];

  const apexDailyData = heatmapDataDaily
    ? Object.entries(heatmapDataDaily)
        // Sort by date first
        .sort(([dateA], [dateB]) => dateA.localeCompare(dateB))
        // Group by weekday and transform to final format
        .reduce(
          (acc: { name: string; data: { x: string; y: number | null }[] }[], [dateTime, value]) => {
            const date = moment(dateTime, 'MM.DD.YYYY');
            const weekday = date.format('ddd'); // Get weekday as Sun, Mon, etc
            const weekOfMonth = Math.ceil(date.date() / 7); // Get week number (1-5)
            const month = date.format('MMM'); // Get month as Jan, Feb, etc
            const xLabel = `${month} W${weekOfMonth}`; // e.g. "Oct W1"

            // Find existing weekday group or create new one
            let weekdayGroup = acc.find((group) => group.name === weekday);
            if (!weekdayGroup) {
              weekdayGroup = { name: weekday, data: [] };
              acc.push(weekdayGroup);
            }

            // Add data point for this week
            weekdayGroup.data.push({
              x: xLabel,
              y: value as number
            });

            return acc;
          },
          []
        )
        // Sort groups by weekday (Sun to Sat)
        .sort((a, b) => {
          const weekdays = ['Sat', 'Fri', 'Thu', 'Wed', 'Tue', 'Mon', 'Sun'];
          return weekdays.indexOf(a.name) - weekdays.indexOf(b.name);
        })
        // Sort data points within each group chronologically
        .map((weekdayGroup) => {
          return {
            ...weekdayGroup,
            data: weekdayGroup.data.sort((a, b) => {
              const [monthA, weekA] = a.x.split(' ');
              const [monthB, weekB] = b.x.split(' ');
              const dateA = moment(monthA, 'MMM')
                .startOf('month')
                .add(Number(weekA[1]) - 1, 'weeks');
              const dateB = moment(monthB, 'MMM')
                .startOf('month')
                .add(Number(weekB[1]) - 1, 'weeks');
              return dateA.diff(dateB);
            })
          };
        })
        // Ensure all weekdays have the same weeks
        .map((weekdayGroup) => {
          // Get all unique week labels across all groups
          const allWeeks = Array.from(
            new Set(
              Object.entries(heatmapDataDaily).map(([date]) => {
                const momentDate = moment(date, 'MM.DD.YYYY');
                const month = momentDate.format('MMM');
                const weekOfMonth = Math.ceil(momentDate.date() / 7);
                return `${month} W${weekOfMonth}`;
              })
            )
          ).sort((a, b) => {
            const [monthA, weekA] = a.split(' ');
            const [monthB, weekB] = b.split(' ');
            const dateA = moment(monthA, 'MMM')
              .startOf('month')
              .add(Number(weekA[1]) - 1, 'weeks');
            const dateB = moment(monthB, 'MMM')
              .startOf('month')
              .add(Number(weekB[1]) - 1, 'weeks');
            return dateA.diff(dateB);
          });

          const completeData = allWeeks.map((week) => {
            const existing = weekdayGroup.data.find((d) => d.x === week);
            return existing || { x: week, y: null };
          });

          return {
            ...weekdayGroup,
            data: completeData
          };
        })
    : [];

  return (
    <>
      <div ref={ZoomOutViewRef} className="flex-1 transition-all mb-4">
        {zoomedChartType === null && (
          <div className="flex flex-wrap flex-1 justify-between">
            <HourlyBoxTrends
              type={deviceType}
              sectionName="Hourly Box Trends"
              interval={0}
              parameter={selectedParameters[0]}
              resizing={resizing}
              noData={!(hourlydata && selectedDevices.length > 0)}
              data={hourlydata ? ChatFormatedData(hourlydata) : []}
              isDataLoading={isDataLoading}
              onZoom={() => onZoom('hourly-box-trends')}
            />

            <HourlyBoxTrends
              type={deviceType}
              data={weeklydata ? ChatFormatedData(weeklydata) : []}
              interval={0}
              parameter={selectedParameters[0]}
              resizing={resizing}
              sectionName="Weekly Box Trends"
              isDataLoading={isDataLoading}
              noData={!(weeklydata && selectedDevices.length > 0)}
              onZoom={() => onZoom('weekly-box-trends')}
            />

            <HourlyBoxTrends
              type={deviceType}
              data={monthlydata ? ChatFormatedData(monthlydata) : []}
              interval={0}
              parameter={selectedParameters[0]}
              resizing={resizing}
              noData={!(monthlydata && selectedDevices.length > 0)}
              sectionName="Monthly Box Trends"
              isDataLoading={isDataLoading}
              onZoom={() => onZoom('monthly-box-trends')}
            />
            {/* <HeatMapTrends
              isDataLoading={isDataLoading}
              data={hourdata}
              xLabels={xhourlyLabels}
              yLabelFormat={(label) => label.split('.').slice(0, 2).join('.')}
              yLabels={yhourlyLabels}
              yLabelWidth="2rem"
              parameter={selectedParameters[0]}
              noData={!(heatmapDataHourly && selectedDevices.length > 0)}
              sectionName="Hourly Map Trends"
              onZoom={() => onZoom('hourly-heat-trends')}
            /> */}
            <ApexHeatMapTrends
              type={deviceType}
              isDataLoading={isDataLoading}
              data={apexHourlyData}
              parameter={selectedParameters[0]}
              resizing={resizing}
              noData={!(heatmapDataHourly && selectedDevices.length > 0)}
              sectionName="Hourly Map Trends"
              onZoom={() => onZoom('hourly-heat-trends')}
            />
            <ApexHeatMapTrends
              type={deviceType}
              isDataLoading={isDataLoading}
              data={apexDailyData}
              parameter={selectedParameters[0]}
              resizing={resizing}
              noData={!(heatmapDataDaily && selectedDevices.length > 0)}
              sectionName="Daily Map Trends"
              onZoom={() => onZoom('daily-heat-trends')}
            />
            {/* <HeatMapTrends
              isDataLoading={isDataLoading}
              data={dailydata}
              xLabels={ydailylabel}
              yLabelWidth="5rem"
              yLabels={xweekLabels}
              noData={!(heatmapDataDaily && selectedDevices.length > 0)}
              parameter={selectedParameters[0]}
              sectionName="Daily Map Trends"
              onZoom={() => onZoom('daily-heat-trends')}
            /> */}
            {/* <HeatMapTrends
              isDataLoading={isDataLoading}
              data={weekdata}
              yLabelWidth="2rem"
              xLabels={xweekLabels}
              noData={!(heatmapDataWeekly && selectedDevices.length > 0)}
              yLabels={yhourlyLabels}
              parameter={selectedParameters[0]}
              sectionName="Weekly Map Trends"
              onZoom={() => onZoom('weekly-heat-trends')}
            /> */}
            <ApexHeatMapTrends
              type={deviceType}
              isDataLoading={isDataLoading}
              data={apexWeeklyData}
              parameter={selectedParameters[0]}
              resizing={resizing}
              noData={!(heatmapDataWeekly && selectedDevices.length > 0)}
              sectionName="Weekly Map Trends"
              onZoom={() => onZoom('weekly-heat-trends')}
            />
            {/* <AlertAnalytics onZoom={() => onZoom('alert-analytics')} /> */}
            {/* <Comparison
              sectionName="Weekly Box Trends"
              onZoom={() => onZoom('weekly-box-comparision')}
            />
            <Comparison
              sectionName="Monthly Box Trends"
              onZoom={() => onZoom('monthly-box-comparision')}
            /> */}
          </div>
        )}
      </div>
      <div className="w-full flex flex-col flex-1" ref={ZoomInViewRef}>
        {zoomedChartType === 'hourly-box-trends' && (
          <HourlyBoxTrends
            type={deviceType}
            parameter={selectedParameters[0]}
            sectionName="Hourly Box Trends"
            interval={0}
            resizing={resizing}
            isDataLoading={isDataLoading}
            noData={!(hourlydata && selectedDevices.length > 0)}
            data={hourlydata ? ChatFormatedData(hourlydata) : []}
            isZoomed
            onBackPress={() => setZoomedChartType(null)}
          />
        )}
        {zoomedChartType === 'weekly-box-trends' && (
          <HourlyBoxTrends
            type={deviceType}
            parameter={selectedParameters[0]}
            sectionName="Weekly Box Trends"
            interval={0}
            resizing={resizing}
            isDataLoading={isDataLoading}
            data={weeklydata ? ChatFormatedData(weeklydata) : []}
            noData={!(weeklydata && selectedDevices.length > 0)}
            isZoomed
            onBackPress={() => setZoomedChartType(null)}
          />
        )}
        {zoomedChartType === 'monthly-box-trends' && (
          <HourlyBoxTrends
            type={deviceType}
            parameter={selectedParameters[0]}
            sectionName="Monthly Box Trends"
            interval={0}
            resizing={resizing}
            isDataLoading={isDataLoading}
            data={monthlydata ? ChatFormatedData(monthlydata) : []}
            noData={!(monthlydata && selectedDevices.length > 0)}
            isZoomed
            onBackPress={() => setZoomedChartType(null)}
          />
        )}
        {zoomedChartType === 'hourly-heat-trends' && (
          <ApexHeatMapTrends
            type={deviceType}
            isDataLoading={isDataLoading}
            data={apexHourlyData}
            parameter={selectedParameters[0]}
            resizing={resizing}
            noData={!(heatmapDataHourly && selectedDevices.length > 0)}
            sectionName="Hourly Map Trends"
            isZoomed
            onBackPress={() => setZoomedChartType(null)}
          />
        )}
        {zoomedChartType === 'daily-heat-trends' && (
          <ApexHeatMapTrends
            type={deviceType}
            isDataLoading={isDataLoading}
            data={apexDailyData}
            parameter={selectedParameters[0]}
            resizing={resizing}
            noData={!(heatmapDataDaily && selectedDevices.length > 0)}
            sectionName="Daily Map Trends"
            isZoomed
            onBackPress={() => setZoomedChartType(null)}
          />
        )}
        {zoomedChartType === 'weekly-heat-trends' && (
          <ApexHeatMapTrends
            type={deviceType}
            isDataLoading={isDataLoading}
            data={apexWeeklyData}
            parameter={selectedParameters[0]}
            resizing={resizing}
            noData={!(heatmapDataWeekly && selectedDevices.length > 0)}
            sectionName="Weekly Map Trends"
            isZoomed
            onBackPress={() => setZoomedChartType(null)}
          />
        )}
        {zoomedChartType === 'alert-analytics' && (
          <AlertAnalytics
            loading={isDataLoading}
            isZoomed
            onBackPress={() => setZoomedChartType(null)}
          />
        )}
      </div>
      {/* {zoomedChartType && <AlertAndSuggestions />} */}
    </>
  );
}
